var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyNoteIcon = function SvgKeyNoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.25 5.46v11.16a3.18 3.18 0 1 0-1.687 5.88 3.19 3.19 0 0 0 3.187-3.188V10.23l9.75-2.813v5.955a3.18 3.18 0 0 0-4.867 2.693 3.187 3.187 0 1 0 6.367 0V1.815zM6.563 21a1.687 1.687 0 1 1 0-3.375 1.687 1.687 0 0 1 0 3.375m11.25-3.248a1.687 1.687 0 1 1 0-3.375 1.687 1.687 0 0 1 0 3.375M19.5 5.857 9.75 8.67V6.592L19.5 3.75z",
    clipRule: "evenodd"
  })));
};
export default SvgKeyNoteIcon;